import { Typography, TypographyProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { RookeryBoldFont } from 'v3/styles/common';

export const StyledTitleMediumTypography = styled(Typography)<TypographyProps>(({ theme }) => ({
  font: `700 1rem ${RookeryBoldFont}`,

  [theme.breakpoints.up('sm')]: {
    font: `500 1rem ${RookeryBoldFont}`,
  },
}));
